<template>
  <div class="mission">
    <div class="container">
      <div class="row">
        <div class="col-md-6 text-center">
          <div class="item p-3">
            <div class="title">
              <div class="d-flex justify-content-center">
                <div class>
                  <i class="fas fa-crosshairs item-icon"></i>
                </div>
                <div class>
                  <p class="company">Our Company</p>
                  <h2>Mission</h2>
                </div>
              </div>
              <p class="section-text text-center p-3">
                To provide our client with complete media-related services to enhance values regarding media exposure
                <br />
                <br />
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-6 text-center">
          <div class="item p-3">
            <div class="title">
              <div class="d-flex justify-content-center">
                <div class>
                  <i class="fas fa-eye item-icon"></i>
                </div>
                <div class>
                  <p class="company">Our Company</p>
                  <h2>Vision</h2>
                </div>
              </div>
              <p
                class="section-text text-center p-3"
              >To create a breakthrough in advertising and communication, emphasizing on the perfect mix of STRATEGY, CREATIVITY and OPTIMAL MEDIA MOBILIZATION</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {};
</script>

<style scoped>
.mission {
  padding: 60px 0;
  border-top: 1px solid #e5e5e5;
}

.item {
  border: 2px solid #111;
}
.item .title .company {
  font-size: 18px;
  font-weight: bold;
  color: #111;
}
.item .title h2 {
  text-transform: uppercase;
  color: #111;
  font-weight: bold;
  line-height: 2px;
}

.item-icon {
  font-size: 4rem;
  margin-right: 25px;
  color: #111;
}
</style>